import { HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { AlertService } from '@app-core';
import { ToastService } from '../services/toast.service';
import { Router } from '@angular/router';
import { ExtendedServerErrorResponse } from './http-response.interface';

export interface ErrorHandlerInterface {
    handle(error: HttpErrorResponse | ExtendedServerErrorResponse): void;
}

// base-error-handler.model.ts
@Injectable()
export abstract class BaseErrorHandlerModel implements ErrorHandlerInterface {
    protected readonly alertService = inject(AlertService);
    protected readonly toastService = inject(ToastService);
    protected readonly router = inject(Router);
    abstract handle(error: ExtendedServerErrorResponse): void;
}
